import React from 'react';
import { FieldValues } from 'react-hook-form';

import { InputAutocomplete } from 'components/Inputs/Input/constants';
import { InputDate } from 'components/Inputs/Input';
import { QuestionDateProps } from './types';
import { QuestionSize } from '../../constants';
import QuestionTemplate from '../';

function QuestionDate<T extends FieldValues>({
  disabled,
  children,
  control,
  id,
  label,
  name,
  readOnly,
  size = QuestionSize.MEDIUM,
  ...props
}: QuestionDateProps<T>) {
  return (
    <QuestionTemplate<T>
      control={control}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      readOnly={readOnly}
      size={size}>
      {({ invalid, onBlur, onChange, ref, value }) => (
        <InputDate
          autoComplete={InputAutocomplete.OFF}
          disabled={disabled}
          id={id}
          inputRef={ref}
          invalid={invalid}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={readOnly}
          size={size}
          value={value as string}
          {...props}>
          {children}
        </InputDate>
      )}
    </QuestionTemplate>
  );
}

export default React.memo(QuestionDate) as typeof QuestionDate;
